import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

const UserListNext = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  
  useEffect(() => {
    const beforePageData = async () => {
      try {
        setUsers(location.state);
      } catch (error) {
        console.error('사용자 목록을 불러오는 중 오류 발생:', error);
      } finally {
        setLoading(false);
      }
    };

    beforePageData();
  }, [location.state]);

  if (loading) return <p>로딩 중...</p>;

  return (
    <div>
      <h2>사용자 목록-2</h2>
      <ul>
        {users.map(user => (
          <li key={user.id}>{user.userNm} ({user.age})</li>
        ))}
      </ul>
    </div>
  );
};

export default UserListNext;
